module.exports = __webpack_public_path__ + "static/media/summa-logo.4c47ea73.png";